import { Component, ElementRef, HostListener, OnInit, ViewChild } from "@angular/core";
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SigninGeneralService } from "../../shared/signinGeneral.service";
@Component({
  selector: 'app-core-layout',
  templateUrl: './core-layout.component.html',
  styleUrls: ['./core-layout.component.scss'],
  standalone: false
})
export class CoreLayoutComponent implements OnInit {
  @ViewChild('c') contentDiv: ElementRef;
  constructor(private router: Router, public generalService: SigninGeneralService) { }
  @HostListener('window:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) { // 2. Explicitly type as KeyboardEvent
    // 3. getModifierState is now safely accessible directly on the typed KeyboardEvent
    if (event.getModifierState) {
      this.generalService.capsLock = event.getModifierState('CapsLock');
    }
  }

  ngOnInit() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe({next:() => {
        try {
          this.contentDiv.nativeElement.scrollTo(0, 0);
        } catch (e) {
          this.contentDiv.nativeElement.scrollTop = 0;
        }
      }}
    );
  }
}
